type Environment = 'main' | 'staging' | 'unstable' | 'stable' | 'dev';

export const getCurrentEnvironment = (): Environment => {
  if (typeof window !== 'undefined') {
    // Code that uses window
    const origin: string = (window as any)?.location?.origin || '';
    if (origin.includes('ims.ufa.com.lb')) {
      return 'main';
    }
    if (origin.includes('staging')) {
      return 'staging';
    } else if (origin.includes('unstable')) {
      return 'unstable';
    } else if (origin.includes('stable')) {
      return 'stable';
    } else if (origin.includes('dev')) {
      return 'dev';
    }
  } else {
    return 'staging';
  }

  return 'staging';
};

export interface IEnviromentData {
  graphBaseUrl: string;
  mainHostUrl: string;
  identityBaseUrl: string;
  identityRedirectUrl: string;
}

export const getEnviromentDetails = (): IEnviromentData => {
  const currentEnv = getCurrentEnvironment();

  switch (currentEnv) {
    case 'main': {
      return {
        graphBaseUrl: 'https://ufapos-api.ufa.com.lb',
        mainHostUrl: 'https://ims.ufa.com.lb',
        identityBaseUrl: 'https://ufapos-id.ufa.com.lb',
        identityRedirectUrl: `https://ims.ufa.com.lb/connect/token`,
      };
    }
    case 'staging': {
      return {
        graphBaseUrl: 'https://ufa-api-staging.baibars.club',
        mainHostUrl: 'https://ufa-ui-staging.baibars.club',
        identityBaseUrl: 'https://ufa-id-staging.baibars.club',
        identityRedirectUrl: `https://ufa-ui-staging.baibars.club/connect/token`,
      };
    }
    case 'unstable': {
      return {
        graphBaseUrl: 'https://ufa-api-unstable.baibars.club',
        mainHostUrl: 'https://ufa-ui-unstable.baibars.club',
        identityBaseUrl: 'https://ufa-id-unstable.baibars.club',
        identityRedirectUrl: `https://ufa-ui-unstable.baibars.club/connect/token`,
      };
    }
    case 'stable': {
      return {
        graphBaseUrl: 'https://ufa-api-stable.baibars.club',
        mainHostUrl: 'https://ufa-ui-stable.baibars.club',
        identityBaseUrl: 'https://ufa-id-stable.baibars.club',
        identityRedirectUrl: `https://ufa-ui-stable.baibars.club/connect/token`,
      };
    }
    case 'dev': {
      return {
        graphBaseUrl: 'https://ufa-api-dev.baibars.club',
        mainHostUrl: 'https://ufa-ui-dev.baibars.club',
        identityBaseUrl: 'https://ufa-id-dev.baibars.club',
        identityRedirectUrl: `https://ufa-ui-dev.baibars.club/connect/token`,
      };
    }
    default: {
      return {
        graphBaseUrl: 'https://ufa-api-dev.baibars.club',
        mainHostUrl: 'https://ufa-ui-dev.baibars.club',
        identityBaseUrl: 'https://ufa-id-dev.baibars.club',
        identityRedirectUrl: `https://ufa-ui-dev.baibars.club/connect/token`,
      };
    }
  }
};

export const supervisorApiBaseUrl = (() => {
  const env = getEnviromentDetails();
  const baseMap: Record<string, string> = {
    'https://ufa-api-staging.baibars.club':
      'https://ufa-supervisor-ca-staging-cfr-01.bluebeach-57574de8.francecentral.azurecontainerapps.io',
    'https://ufapos-api.ufa.com.lb':
      'https://ufa-supervisor-ca-cfr-01.thankfulbay-9790b718.francecentral.azurecontainerapps.io',
    'https://ufa-api-unstable.baibars.club':
      'https://ufa-supervisor-ca-unstable-cfr-01.ashyfield-dcc5359b.francecentral.azurecontainerapps.io',
    'https://ufa-api-stable.baibars.club':
      'https://ufa-supervisor-ca-stable-cfr-01.ashyfield-dcc5359b.francecentral.azurecontainerapps.io',
    'https://ufa-api-dev.baibars.club':
      'https://ufa-supervisor-ca-dev-cfr-01.ashyfield-dcc5359b.francecentral.azurecontainerapps.io',
  };
  return (
    baseMap[env.graphBaseUrl] || baseMap['https://ufa-api-dev.baibars.club']
  );
})();

export const isProd = () => {
  const origin: string = (window as any)?.location?.origin || '';
  return origin.includes('ims.ufa.com.lb');
};

export const TinyMCEApiKey = '1zpxcry8s9a6chrmtwzhr9g4fpr8m1fywjo4eq76vdj33per';
